module.exports = __webpack_public_path__ + "img/4.73ab895f.png";